
import React from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import Gallery from '../components/home/Gallery';
import Testimonials from '../components/home/Testimonials';
import { Button } from '@/components/ui/button';
import { ArrowUp } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import useScrollToTop from '@/hooks/use-scroll-to-top';
import { cn } from '@/lib/utils';

const Index = () => {
  const isMobile = useIsMobile();
  // Ensure that we always scroll to top when navigating to the home page
  useScrollToTop();
  
  return <Layout>
      <Hero />
      <Services />
      <div className={cn(
        "bg-brand-green text-white text-center",
        isMobile ? "py-12" : "py-24"
      )}>
        <div className="container-tight">
          <h2 className="section-title mb-6 md:mb-8 text-3xl md:text-5xl">
            {isMobile ? 'Prêt à transformer votre espace?' : 'Prêt à transformer votre espace extérieur?'}
          </h2>
          <p className="text-lg md:text-xl mb-6 md:mb-10 text-gray-200 max-w-3xl mx-auto">
            {isMobile ? 'Contactez notre équipe pour une consultation gratuite.' : 'L\'équipe experte d\'Entretiens McBain est prête à réaliser votre vision avec précision et créativité. Contactez-nous dès aujourd\'hui pour une consultation gratuite.'}
          </p>
          {isMobile ? (
            <Button href="/quote" size="lg" className="bg-white text-brand-green-dark hover:bg-brand-stone hover:text-brand-green-dark font-medium w-full">
              Demander un devis gratuit
            </Button>
          ) : (
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button href="/contact" size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-brand-green-dark font-medium">
                Contactez-nous
              </Button>
              <Button href="/quote" size="lg" className="bg-white text-brand-green-dark hover:bg-brand-stone hover:text-brand-green-dark font-medium">
                Demander un devis gratuit
              </Button>
            </div>
          )}
        </div>
      </div>
      {!isMobile && <Gallery />}
      <Testimonials />
      
      {/* Scroll to top button */}
      <button id="scroll-to-top" onClick={() => window.scrollTo({top:0,behavior:'smooth'})} className="fixed right-6 bottom-6 z-50 bg-brand-green text-white p-3 rounded-full shadow-lg opacity-0 pointer-events-none transition-opacity duration-300" aria-label="Scroll to top">
        <ArrowUp size={isMobile ? 20 : 24} />
      </button>
    </Layout>;
};

export default Index;
